import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarV2SearchIcon from './VeltCommentsSidebarV2SearchIcon/VeltCommentsSidebarV2SearchIcon';
import VeltCommentsSidebarV2SearchInput from './VeltCommentsSidebarV2SearchInput/VeltCommentsSidebarV2SearchInput';
var VeltCommentsSidebarV2Search = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-search-v2-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2Search.Icon = VeltCommentsSidebarV2SearchIcon;
VeltCommentsSidebarV2Search.Input = VeltCommentsSidebarV2SearchInput;
export default VeltCommentsSidebarV2Search;
